// eslint-disable-next-line no-shadow
export enum Ranks {
  Especialidade = 'specialties',
  Cidade = 'cities',
  Dia = 'week-days',
  Hospital = 'contractors',
}
